module.exports = __webpack_public_path__ + "img/p3_2.3dea6efc.png";